import React from "react";
import {
  Box,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  useBreakpointValue,
} from "@chakra-ui/react";
import LoggedNavigation from "./LoggedNavigation";

const ResponsiveSidebarWrapper = ({ accessPages, isOpen, onClose }) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box display="flex">
      {!isMobile && <LoggedNavigation accessPages={accessPages} isMobile={isMobile} onClose={onClose}/>}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} bg='red'>
        <DrawerOverlay />
        <DrawerContent style={{width: '0%'}} bg="transparent" boxShadow="none">
            <LoggedNavigation accessPages={accessPages} isMobile={isMobile} onClose={onClose}/>
          <DrawerBody p={0}/>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default ResponsiveSidebarWrapper;
